package com.fireavert.common

import kotlin.math.round

// Extension functions for common utilities


// Converts a Double to a String with one decimal place, ensuring that it always has one digit after the decimal point.
fun Double.toOneDecimal(): String {
    val multiplier = 10.0
    val rounded = round(this * multiplier) / multiplier

    val str = rounded.toString()
    val decimalIndex = str.indexOf('.')

    return if (decimalIndex == -1) {
        "$str.0"
    } else {
        val currentDecimalPlaces = str.length - decimalIndex - 1
        when {
            currentDecimalPlaces < 1 -> str + "0"
            currentDecimalPlaces > 1 -> str.substring(0, decimalIndex + 2)
            else -> str
        }
    }
}

fun String.formatNumberWithCommas(): String {
    val reversed = this.reversed()
    val chunked = reversed.chunked(3)
    val joined = chunked.joinToString(separator = ",")
    return joined.reversed()
}